import React, { useEffect, useState } from "react";
import { useParams, useNavigate, Link } from "react-router-dom";
import { fetchLeagueBySlug } from "../lib/api";
import { writePrefs } from "../lib/prefs";

// Deep-link route at /<slug>. Resolves the slug → league_id → opens the
// existing LeagueDetailModal so PRO landing pages share the same UI.
// When the slug doesn't match a league, this is most likely a typo or an
// unknown URL — we render a generic "Page not found" rather than the
// confusing "404 — NO LEAGUE" which implied a league-specific dead end.
export function LeagueBySlugPage({ onOpenLeague, onToast }) {
  const { slug } = useParams();
  const navigate = useNavigate();
  const [error, setError] = useState("");

  useEffect(() => {
    let cancelled = false;
    fetchLeagueBySlug(slug)
      .then((d) => {
        if (cancelled) return;
        // Remember this slug so the landing page can offer a "Resume in X" CTA.
        try { writePrefs({ last_league_slug: slug }); } catch { /* ignore */ }
        onOpenLeague?.(d.league_id);
        navigate("/", { replace: true });
      })
      .catch((e) => {
        if (cancelled) return;
        setError(e?.response?.data?.detail || "Page not found.");
      });
    return () => { cancelled = true; };
  }, [slug, navigate, onOpenLeague, onToast]);

  return (
    <main className="page-z" data-testid="slug-page">
      <div className="max-w-xl mx-auto px-6 lg:px-10 pt-20 pb-20 text-center">
        {!error ? (
          <>
            <div className="loader-ring mx-auto" />
            <p className="mt-4 text-sm text-white/60">
              Opening <span className="font-mono text-white/80">leaguehub.co/{slug}</span>…
            </p>
          </>
        ) : (
          <>
            <h2
              data-testid="page-not-found-heading"
              className="font-display text-3xl text-[#14b8a6]"
            >
              404 — PAGE NOT FOUND
            </h2>
            <p className="mt-3 text-white/70">
              The page <span className="font-mono text-white/85">/{slug}</span> doesn't exist.
            </p>
            <p className="mt-1 text-white/45 text-xs">
              Looking for a league? Try the{" "}
              <Link to="/leagues" className="underline text-[#14b8a6]">leagues directory</Link>.
            </p>
            <Link
              to="/"
              data-testid="page-not-found-home-btn"
              className="inline-block mt-6 btn-neon rounded-2xl px-6 py-3 text-xs tracking-widest"
            >
              BACK TO ROADMAP
            </Link>
          </>
        )}
      </div>
    </main>
  );
}

export default LeagueBySlugPage;
